// extracted by mini-css-extract-plugin
export var dropOver = "_im-2";
export var dropValid = "_im-1";
export var hidden = "_im-3";
export var line = "_im-0";